const baseStyle = () => ({
  root: {
    width: '100%',
    maxWidth: '1568px',
    margin: '0 auto',
    px: { base: '16px', xl: '40px' },
  },
});

const theme = { baseStyle };
export default theme;
